// extracted by mini-css-extract-plugin
export default {"addressSection":"iT-z","disabled":"jT-z","sectionButtons":"kT-z","logo":"lT-z"};